interface CacheEntry<T> {
  data: T
  timestamp: number
}

const CACHE_DURATION = 5 * 60 * 1000 // 5 minutes

export const cache = {
  set<T>(key: string, data: T): void {
    const entry: CacheEntry<T> = {
      data,
      timestamp: Date.now(),
    }
    try {
      sessionStorage.setItem(key, JSON.stringify(entry))
    } catch (error) {
      console.warn('Failed to cache data:', error)
    }
  },

  get<T>(key: string): T | null {
    try {
      const item = sessionStorage.getItem(key)
      if (!item) return null

      const entry: CacheEntry<T> = JSON.parse(item)
      const age = Date.now() - entry.timestamp

      if (age > CACHE_DURATION) {
        sessionStorage.removeItem(key)
        return null
      }

      return entry.data
    } catch (error) {
      console.warn('Failed to read cache:', error)
      return null
    }
  },

  clear(key?: string): void {
    if (key) {
      sessionStorage.removeItem(key)
    } else {
      sessionStorage.clear()
    }
  },
}
